var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment-tombstone",attrs:{"data-testid":"comment-tombstone"}},[_c('div',{staticClass:"comment-tombstone__avatar",attrs:{"aria-hidden":"true"}},[_c('v-icon',{attrs:{"size":"20","color":"#667085"}},[_vm._v("mdi-account")])],1),_c('p',{staticClass:"comment-tombstone__body"},[_vm._v("This comment was deleted.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }